import { RevealOnScroll } from "./Reveal";
import WorldMap from "./WorldMap";
import { motion } from "framer-motion";

const CORRIDORS = [
  { from: "Shanghai",  to: "Accra",        days: "28 days" },
  { from: "Yokohama",  to: "Accra",        days: "34 days" },
  { from: "Hamburg",   to: "Casablanca",   days: "12 days" },
  { from: "Rotterdam", to: "Casablanca",   days: "11 days" },
  { from: "Dubai",     to: "Nairobi",      days: "14 days" },
];

export default function GlobalNetwork() {
  return (
    <section data-testid="global-network" className="section-y-lg bg-ink border-t border-white/5">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 md:gap-16 mb-20 md:mb-28">
          <div className="col-span-12 md:col-span-7">
            <motion.span
              initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
              className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
            />
            <div className="overline text-[#C5A059] mb-6">Global Presence</div>
            <RevealOnScroll
              element="h2"
              className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight"
              lines={["Corridors, not borders.", "<em>Africa</em> at the centre."]}
            />
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8 md:pt-6">
            <p className="editorial-body">
              Africa is the destination. From Accra to Lagos, Nairobi to Casablanca
              to Johannesburg — Maklan operates quiet sourcing corridors from the
              great manufacturing capitals into the continent's ports.
            </p>
          </div>
        </div>

        <WorldMap />

        <div className="mt-20 grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-12 pt-10 border-t border-white/10">
          {CORRIDORS.map((c, i) => (
            <motion.div
              key={c.from}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 1.1, delay: i * 0.06 }}
              data-testid={`corridor-${c.from.toLowerCase()}`}
            >
              <div className="text-[10px] tracking-[0.28em] uppercase text-white/40 mb-3">Corridor</div>
              <div className="font-display text-2xl md:text-3xl leading-tight">{c.from}</div>
              <div className="text-[#C5A059] text-sm mt-1">→ {c.to}</div>
              <div className="mt-4 text-xs text-white/50 tracking-wide">{c.days}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
